export const DELAYED_RADIO_PROCESSING = 'delayed_radio_processing';
export const MULTI_COMPANY_ACCESS = 'multi_company_access';
